import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHEContainer } from 'data/components';

class ContainerLayout extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        loading: PropTypes.bool,
        withoutFHEContainer: PropTypes.bool,
        error: PropTypes.string,
        onClickFunc: PropTypes.func,
        children: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired
    };
    static defaultProps = {
        withoutFHEContainer: false,
        loading: false,
        error: '',
        onClickFunc: null
    };
    renderChildren = () => {
        const { children } = this.props;
        return children;
    };
    render() {
        const { classes, loading, error, onClickFunc, withoutFHEContainer, location } = this.props;
        let background = location.modal && location.modal.background;

        return (
            <div className={`${classes.containerEnv} ${background ? '' : classes.zIndexForModal}`}>
                {withoutFHEContainer ? (
                    this.renderChildren()
                ) : (
                    <FHEContainer
                        hasNoClassContainer={!loading && !error}
                        loading={loading}
                        error={error}
                        onClickFunc={onClickFunc}
                        onRender={this.renderChildren}
                    />
                )}
            </div>
        );
    }
}

const styles = theme => ({
    zIndexForModal: {
        zIndex: 1
    },
    containerEnv: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
        overflowY: 'auto',
        paddingTop: 150,
        padding: 60,
        [theme.breakpoints.down('md')]: {
            paddingTop: 140,
            padding: 15
        },
        [theme.breakpoints.down('sm')]: {
            paddingTop: 130
            // padding: 15
        },
        [theme.breakpoints.down('xs')]: {
            paddingTop: 145,
            padding: 6
            // height: 'auto'
        }
    },
    containerProgress: {
        display: 'flex',
        justifyContent: 'center'
    },
    containerError: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    button: {
        margin: '40px 0'
    },
    progress: {
        margin: theme.spacing(2)
    }
});

export default withRouter(withStyles(styles, { withTheme: true })(ContainerLayout));



// WEBPACK FOOTER //
// ./data/components/ContainerLayout.js